import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getShelfShoppingPackages } from "../../../../helper/functions";
import { setPackages } from "../../../../store/commonSlice";

/**
 * Custom hook to fetch packages for selected shopping user
 * @returns {boolean} Loading state
 */
export const useShoppingPackages = () => {
  const dispatch = useDispatch();
  const { selectedRequest: userActiveData } = useSelector(
    (state) => state.common
  );
  const user = useSelector((state) => state.auth.value);
  const [loading, setLoading] = useState(false);

  const getPackages = async () => {
    try {
      console.log(userActiveData, "userActiveDataddv");

      if (userActiveData?.id) {
        setLoading(true);
        dispatch(setPackages([]));
        const shelfPackage = await getShelfShoppingPackages([
          {
            key: "mySuiteId",
            operator: "==",
            value: userActiveData?.id,
          },
        ]);
        console.log(shelfPackage, "shelfPAckages in pacjjm");
        dispatch(setPackages(shelfPackage));
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching shopping packages:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getPackages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, userActiveData]);

  return loading;
};

